import type { AuditColumnKey } from "@/modules/audit";
import type { FilterDefinition, ToastApi } from "@/ds";
import { exportAuditRecords } from "@/modules/audit";
import type { AuditFilters, AuditSort } from "@/modules/audit";
import { createExportFeedback, describeReportFilters, useFileExport } from "@/modules/export";
import { AUDIT_EXPORT_FILE_NAME } from "../audit.constants";
import { toPanelValue } from "../audit.utils";

interface UseAuditExportacaoParams {
  /** Colunas visíveis da tela, na ordem; a exportação leva só elas. */
  readonly colunas: readonly AuditColumnKey[];
  readonly filters: AuditFilters;
  readonly sort: AuditSort;
  readonly filterColumns: FilterDefinition[];
  /** Listagem vazia: Exportar Visualização avisa "nada a exportar" sem pedir o arquivo. */
  readonly isEmpty: boolean;
  readonly toast: ToastApi;
}

/**
 * Exportar Visualização (HU 1442): o arquivo é gerado pelo servidor (`/auditoria/exportar`) com os filtros e a
 * ordenação em vigor, sem paginação (RN003), e o servidor registra a exportação na auditoria.
 */
export function useAuditExportacao({
  colunas,
  filters,
  sort,
  filterColumns,
  isEmpty,
  toast,
}: UseAuditExportacaoParams) {
  return useFileExport({
    fileName: AUDIT_EXPORT_FILE_NAME,
    loadFile: (format) =>
      exportAuditRecords({
        ...filters,
        sort,
        filtros: describeReportFilters(undefined, filterColumns, toPanelValue(filters)),
        colunas,
        format,
      }),
    isEmpty: () => isEmpty,
    ...createExportFeedback(toast),
  });
}
